import { render, staticRenderFns } from "./read_stats.vue?vue&type=template&id=3bac9a14&scoped=true&"
import script from "./read_stats.vue?vue&type=script&lang=js&"
export * from "./read_stats.vue?vue&type=script&lang=js&"
import style0 from "./read_stats.vue?vue&type=style&index=0&id=3bac9a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac9a14",
  null
  
)

export default component.exports